import  axiosClient  from "../Network/apiClient"
const UploadService = {
    getImage: (id) => {
        return axiosClient.get(`/uploads/${id}/image`, { responseType: 'blob'})
    },
    getImageUrl: (id) => {
        return `${process.env.REACT_APP_BASEURL}/uploads/${id}/image`;
    },
    getThumb: (id) => {
        return axiosClient.get(`/uploads/${id}/thumb`, { responseType: 'blob'})
    },
    getThumbUrl: (id) => {
        return `${process.env.REACT_APP_BASEURL}/uploads/${id}/thumb`;
    },
    create: (upload) =>  {
        const formData= new FormData()
        formData.append('id', upload.id)
        formData.append('origname', upload.origname)
        formData.append('publish', upload.publish)
        formData.append('folderId', upload.folderId)
        formData.append('author', upload.author)
        formData.append('delstaId', upload.delstaId)
        formData.append('file', upload.file)
        return axiosClient.post(`/uploads`, formData, { contentType: 'multipart/form-data' })
    },
    update: (upload) =>  {
        return axiosClient.put(`/uploads/`, JSON.stringify(upload));
    },

}
export default UploadService
